import React from 'react'

const ActionLink = ({ id, className, onClick, children, title, name }) => <span id={id} className={`${className} u-link a`} name={name || id} onClick={onClick} title={title}>{children}</span>

export default ActionLink
